export const List = () => import("./List.vue");
export const RemovedStockItem = () => import("./RemovedStockItem.vue");
export const Barcode = () => import("./Barcode.vue");
export const BarcodeSingle = () => import("./BarcodeSingle.vue");
export const Create = () => import("./Create.vue");
export const Edit = () => import("./Edit.vue");
export const ListDemo = () => import("./List-Demo.vue");
